const Login = () => import(/* webpackChunkName: "account" */ './login/Login.vue')

export default {
  path: '/login',
  name: 'login',
  meta: {
    title: 'Log In',
    allowUnauthorized: true
  },
  component: Login
}
